import React, { useEffect } from "react";
import { alpha, Box, Grid, styled, useTheme } from "@mui/material";
import CustomContainer from "../../../container";
import FeaturedCategories from "../../featured-categories";
import Banners from "../../banners";
import { IsSmallScreen } from "../../../../utils/CommonValues";
import VisitAgain from "../../visit-again";
import SpecialFoodOffers from "../../special-food-offers";
import BestReviewedItems from "../../best-reviewed-items";
import Stores from "../../stores";
import NewArrivalStores from "../../new-arrival-stores";
import RunningCampaigns from "../../running-campaigns";
import FeaturedCategoriesWithFilter from "../ecommerce/FeaturedCategoriesWithFilter";
import LoveItem from "../../love-item";
import useGetOtherBanners from "../../../../api-manage/hooks/react-query/useGetOtherBanners";
import OrderDetailsModal from "../../../order-details-modal/OrderDetailsModal";
import { useSelector } from "react-redux";
import { getToken } from "../../../../helper-functions/getToken";
import { getCurrentModuleId } from "../../../../helper-functions/getCurrentModuleType";

const SectionWrapper = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.down("sm")]: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

const HeroSection = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
}));

const ContentSection = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(5),
  backgroundColor: theme.palette.mode === 'dark' 
    ? alpha(theme.palette.background.paper, 0.3)
    : alpha(theme.palette.primary.main, 0.02),
  borderRadius: "24px",
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    borderRadius: "16px",
  },
}));

const FoodModule = (props) => {
  const { configData } = props;
  const theme = useTheme();
  const token = getToken();
  const { orderDetailsModalOpen } = useSelector((state) => state.utilsData);
  const { data, refetch, isLoading } = useGetOtherBanners();
  useEffect(() => {
    refetch();
  }, []);
  const visitedStores = localStorage.getItem("visitedStores")
    ? JSON.parse(localStorage.getItem("visitedStores"))?.length > 0
      ? JSON.parse(localStorage.getItem("visitedStores"))?.filter(
          (item) => item?.module_id === getCurrentModuleId()
        )
      : []
    : [];
  return (
    <Box sx={{ width: "100%", backgroundColor: theme.palette.background.default }}>
      <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
        {/* HERO SECTION - Featured Categories */}
        <Grid item xs={12}>
          <HeroSection>
            <CustomContainer>
              <FeaturedCategories configData={configData} />
            </CustomContainer>
          </HeroSection>
        </Grid>

        {/* QUICK ACCESS SECTION - Visit Again */}
        <Grid item xs={12}>
          <SectionWrapper>
            {IsSmallScreen() ? (
              <VisitAgain configData={configData} visitedStores={visitedStores} />
            ) : (
              <CustomContainer>
                <VisitAgain configData={configData} visitedStores={visitedStores} />
              </CustomContainer>
            )}
          </SectionWrapper>
        </Grid>

        {/* SPECIAL FOOD OFFERS SECTION */}
        <Grid item xs={12}>
          <ContentSection>
            <CustomContainer>
              <SpecialFoodOffers title="Special Food Offers" />
            </CustomContainer>
          </ContentSection>
        </Grid>

        {/* PROMOTIONAL BANNERS SECTION */}
        <Grid item xs={12}>
          <SectionWrapper>
            <CustomContainer>
              <Banners />
            </CustomContainer>
          </SectionWrapper>
        </Grid>

        {/* BEST REVIEWED SECTION */}
        <Grid item xs={12}>
          <ContentSection>
            <CustomContainer>
              <BestReviewedItems title="Best Reviewed Items" info={data} />
            </CustomContainer>
          </ContentSection>
        </Grid>

        {/* RECOMMENDED FOR YOU SECTION */}
        <Grid item xs={12}>
          <SectionWrapper>
            <CustomContainer>
              <LoveItem />
            </CustomContainer>
          </SectionWrapper>
        </Grid>

        {/* NEW ARRIVALS SECTION */}
        <Grid item xs={12}>
          <ContentSection>
            <CustomContainer>
              <NewArrivalStores />
            </CustomContainer>
          </ContentSection>
        </Grid>

        {/* RUNNING CAMPAIGNS SECTION */}
        <Grid item xs={12}>
          <SectionWrapper>
            <CustomContainer>
              <RunningCampaigns />
            </CustomContainer>
          </SectionWrapper>
        </Grid>

        {/* FEATURED CATEGORIES WITH FILTER SECTION */}
        <Grid item xs={12}>
          <ContentSection>
            <CustomContainer>
              <FeaturedCategoriesWithFilter title="Featured Categories" />
            </CustomContainer>
          </ContentSection>
        </Grid>

        {/* ALL STORES SECTION */}
        <Grid item xs={12}>
          <SectionWrapper sx={{ paddingBottom: { xs: 4, md: 6 } }}>
            <CustomContainer>
              <Stores />
            </CustomContainer>
          </SectionWrapper>
        </Grid>
      </Grid>
      {orderDetailsModalOpen && !token && (
        <OrderDetailsModal orderDetailsModalOpen={orderDetailsModalOpen} />
      )}
    </Box>
  );
};

FoodModule.propTypes = {};

export default FoodModule;
